<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-WeiShengJian`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.25 11.8672H3.875M3.875 11.8672V16.1797C3.875 17.8366 5.21815 19.1797 6.875 19.1797H17.125C18.7819 19.1797 20.125 17.8366 20.125 16.1797V11.8672M3.875 11.8672H20.125M20.125 11.8672H21.75" stroke="#333" stroke-linecap="round"/><path d="M5.5 11.875V4.5C5.5 4.08578 5.83579 3.75 6.25 3.75H9.21874C9.63297 3.75 9.96874 4.08579 9.96874 4.5V6.1875H12M9.96873 6.1875H7.9375" stroke="#333" stroke-linecap="round"/><path d="M8.14062 8.46094C8.47717 8.46094 8.75 8.18811 8.75 7.85156 8.75 7.51501 8.47717 7.24219 8.14062 7.24219 7.80408 7.24219 7.53125 7.51501 7.53125 7.85156 7.53125 8.18811 7.80408 8.46094 8.14062 8.46094zM10.1719 8.46094C10.5084 8.46094 10.7812 8.18811 10.7812 7.85156 10.7812 7.51501 10.5084 7.24219 10.1719 7.24219 9.83533 7.24219 9.5625 7.51501 9.5625 7.85156 9.5625 8.18811 9.83533 8.46094 10.1719 8.46094zM12.2031 8.46094C12.5397 8.46094 12.8125 8.18811 12.8125 7.85156 12.8125 7.51501 12.5397 7.24219 12.2031 7.24219 11.8666 7.24219 11.5938 7.51501 11.5938 7.85156 11.5938 8.18811 11.8666 8.46094 12.2031 8.46094z" :fill="useCurrentColor ? 'currentColor' : '#333'"/><path d="M8.34375 19.1797V21.211M15.6562 19.1797V21.211" stroke="#333" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconWeiShengJian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
